import Keycloak from "keycloak-js";
import  { urlMap } from "./env"


export const keycloak = new Keycloak({
    realm: "codex",
    url: urlMap.get(window.location.origin),
    clientId: "frontend",
})
